var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsDashboard = function SvgFormsDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F6771",
    d: "M22.75 2.5H37.5v10.25H22.75zM2.5 2.5h14.75v19.25H2.5zM22.75 18.25H37.5V37.5H22.75zM2.5 27.25h14.75V37.5H2.5z"
  })));
};
export default SvgFormsDashboard;